import Head from "next/head";

const Schema = ({ name, slogan, phone, address, menu, url = "" }) => {
  const { street, street_number, zip_code, city, country, lat, long } = address;
  const formatedMenu = formateMenu(menu);
  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: `
    {
      "@context":"https://schema.org/",
      "@type":"Restaurant",
      "image": "https://pbs.twimg.com/profile_images/1067371343572844545/uTB3J4jG_400x400.jpg",
      "name":"${name}",
      "description": "${slogan}",
      "telephone": "${phone}",
      "url": "${url}",
      "address": {
        "@type":"PostalAddress",
        "streetAddress": "${street_number} ${street}",
        "addressLocality": "${city}",
        "postalCode": "${zip_code}",
        "addressCountry": "${country}"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "${lat}",
        "longitude": "${long}"
      },
      "hasMenu": {
        "@type": "Menu",
        "name": "Menu restaurant",
        "hasMenuSection": [${formatedMenu}]
      }
    }
    `,
        }}
      ></script>
    </Head>
  );
};

function formateMenu(datas) {
  const result = datas.reduce((acc, data) => {
    const section = {
      "@type": "MenuSection",
      name: data.name,
    };
    const isMenu = data.products.some(
      (product) => product.menu_levels && product.menu_levels.length
    );
    if (isMenu) {
      section.hasMenuSection = data.products.reduce((accMenu, product) => {
        const menuSection = {
          "@type": "MenuSection",
          name: product.name,
          description: product.description,
          offers: {
            "@type": "Offer",
            price: product.price,
            priceCurrency: "EUR",
          },
        };
        menuSection.hasMenuSection = product.menu_levels.reduce(
          (accSubSec, level) => {
            const subSection = {
              "@type": "MenuSection",
              name: level.name,
            };
            subSection.hasMenuItem = level.products.reduce(
              (accItems, product) => {
                const item = {
                  "@type": "MenuItem",
                  name: product.name,
                  description: product.description,
                };
                if (product.extraCategories.length) {
                  item.menuAddOn = product.extraCategories.reduce(
                    (accSupps, extraCategory) => {
                      const section = {
                        "@type": "MenuSection",
                        name: extraCategory.name,
                      };
                      section.hasMenuItem = extraCategory.data.reduce(
                        (accItems, supp) => {
                          const item = {
                            "@type": "MenuItem",
                            name: supp.name,
                          };
                          accItems.push(item);
                          return accItems;
                        },
                        []
                      );
                      accSupps.push(section);
                      return accSupps;
                    },
                    []
                  );
                }
                accItems.push(item);
                return accItems;
              },
              []
            );
            accSubSec.push(subSection);
            return accSubSec;
          },
          []
        );
        accMenu.push(menuSection);
        return accMenu;
      }, []);
    } else {
      section.hasMenuItem = data.products.reduce((accItems, product) => {
        const item = {
          "@type": "MenuItem",
          name: product.name,
          description: product.description,
          offers: {
            "@type": "Offer",
            price: product.price,
            priceCurrency: "EUR",
          },
        };
        if (product.extraCategories.length) {
          item.menuAddOn = product.extraCategories.reduce(
            (accSupps, extraCategory) => {
              const section = {
                "@type": "MenuSection",
                name: extraCategory.name,
              };
              section.hasMenuItem = extraCategory.data.reduce(
                (accItems, supp) => {
                  const item = {
                    "@type": "MenuItem",
                    name: supp.name,
                  };
                  accItems.push(item);
                  return accItems;
                },
                []
              );
              accSupps.push(section);
              return accSupps;
            },
            []
          );
        }
        accItems.push(item);
        return accItems;
      }, []);
    }

    acc.push(JSON.stringify(section));
    return acc;
  }, []);

  return result;
}
export default Schema;
